import { render, staticRenderFns } from "./FooterMobile.vue?vue&type=template&id=18375a62&"
import script from "./FooterMobile.vue?vue&type=script&lang=js&"
export * from "./FooterMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports